<template>
  <div class="wrap_m">
    <!--<div style="position: absolute;z-index: 5;color: black;font-size: 20px;">{{swiperindex}}</div>-->
    <div class="line-wrap">
      <div class="line-1">
        <div v-for="(item, index) in list" :key="index + 'id'">
          <div
            v-if="swiperindex == 0 || swiperindex == 2"
            :class="swiperindex == index ? 'line lineactive' : 'line whiteLine'"
          ></div>
          <div
            v-else
            :class="
              swiperindex == index ? 'line lineactive2' : 'line whiteLine'
            "
          ></div>
        </div>
      </div>
    </div>
    <img
      class="img-1ogo"
      :class="
        swiperindex == 0 || swiperindex == 1 ? 'img-1ogo-1' : 'img-1ogo-2'
      "
      :src="
        swiperindex == 0 || swiperindex == 2
          ? 'http://www.heywoods.cn/newImage/2-logo.png'
          : 'http://www.heywoods.cn/newImage/2-logo-black.png'
      "
    />
    <div class="reference">
      <p>
        <a
          href="http://www.beian.miit.gov.cn"
          :class="
            swiperindex == 0 || swiperindex == 2 ? 'whiteColor' : 'blackColor'
          "
          >广州小黑屋科技有限公司 版权所有</a
        >
      </p>
      <p>
        <a
          href="http://beian.miit.gov.cn"
          :class="
            swiperindex == 0 || swiperindex == 2 ? 'whiteColor' : 'blackColor'
          "
          >粤ICP备17009904号-1</a
        >
      </p>
      <p>
        <img src="../../images/jin.png" class="jinhui" />
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010502002393"
          :class="
            swiperindex == 0 || swiperindex == 2 ? 'whiteColor' : 'blackColor'
          "
          >粤公网安备 44010502002391号</a
        >
      </p>
    </div>
    <div class="remind" v-if="swiperindex != 5" @click="slideTo">
      <img
        class="remindAni"
        :src="
          swiperindex == 0 || swiperindex == 2
            ? 'http://www.heywoods.cn/newImage/3.png'
            : 'http://www.heywoods.cn/newImage/13.png'
        "
      />
    </div>
    <div class="mySwiper_wrap">
      <swiper :options="swiperOption" ref="mySwiper" class="carousel_m">
        <swiper-slide class="item_m">
          <img
            class="videoClass"
            src="http://www.heywoods.cn/newImage/mobile-p1-bk.jpg"
          />
          <img
            class="img-1-m"
            src="http://www.heywoods.cn/newImage/mobile-p1-word.jpg"
          />
        </swiper-slide>

        <swiper-slide class="item_m">
          <div class="page-2-content">
            <img
              class="videoClass"
              src="http://www.heywoods.cn/newImage/mibile-p2-bk.jpg"
            />
            <img
              class="img-2-m"
              src="http://www.heywoods.cn/newImage/mobile-p2-word-middle.png"
            />
          </div>
        </swiper-slide>
        <swiper-slide class="item_m">
          <div class="page-2-header" style="left: 10%">
            <div class="page-2-title">
              <span style="color: white">企业文化</span>
            </div>
            <div class="page-2-info" style="color: white">Culture</div>
          </div>
          <img
            class="page-3-img"
            src="http://www.heywoods.cn/newImage/7-m.png"
          />
          <img
            id="page-3-img2"
            :class="
              swiperindex == 2 ? 'page-3-img2 page-3-img2-Ani' : 'page-3-img2'
            "
            src="http://www.heywoods.cn/newImage/culture.jpg"
          />
        </swiper-slide>
        <swiper-slide class="item_m">
          <img
            class="miniproImg-4"
            src="http://www.heywoods.cn/newImage/8-m.png"
          />
          <div class="page-2-content">
            <div class="page-2-content-wrap">
              <div class="page-2-header">
                <div class="page-2-title">
                  <span>员工福利</span>
                </div>
                <div class="page-2-info">Staff Welfare</div>
              </div>
            </div>
          </div>
          <div class="page-4-img">
            <img
              :class="swiperindex == 3 ? 'page-4-Ani' : ''"
              src="http://www.heywoods.cn/newImage/staff.jpg"
            />
          </div>
        </swiper-slide>
        <swiper-slide class="item_m">
          <img
            class="miniproImg"
            src="http://www.heywoods.cn/newImage/9-m.png"
          />
          <div class="page-2-content">
            <div class="page-2-content-wrap">
              <div class="page-2-header">
                <div class="page-2-title">
                  <span>人才招聘</span>
                </div>
                <div class="page-2-info">Recruitment</div>
              </div>
              <div class="page-5-rec">
                <div
                  v-for="(item, index) in recArrTitle"
                  class="page-5-title-warp"
                  v-bind:key="index + 'id'"
                >
                  <div
                    :class="
                      currentwidth > 320
                        ? 'page-5-title titleSize'
                        : 'page-5-title'
                    "
                    @click="tabClick(index)"
                  >
                    <p class="title">
                      {{ item
                      }}<span
                        :class="itemIndex == index ? 'borderActive' : ''"
                      ></span>
                    </p>
                  </div>
                </div>
                <div
                  v-for="(item, index) in recArrContent"
                  class="page-2-info-list"
                  v-show="itemIndex == index"
                  v-bind:key="index + 'id'"
                >
                  <div
                    v-for="(item2, index2) in item.content"
                    v-bind:key="index2 + 'id'"
                  >
                    <p
                      :class="
                        currentwidth > 320
                          ? 'page-2-info-list-item titlesize2'
                          : 'page-2-info-list-item'
                      "
                    >
                      {{ index2 + 1 }}、{{ item2 }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="page-5-end">
                <div>
                  简历请发送到邮箱：hr@heywoods.cn<span class="color-gray"
                    >（邮件请标注职位+姓名）</span
                  >
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="item_m">
          <div class="page-2-content-wrap">
            <img
              class="miniproImg-6"
              src="http://www.heywoods.cn/newImage/10-m.png"
            />
            <div class="page-2-header">
              <div class="page-2-title">
                <span>社会责任</span>
                <div></div>
                <span>公益</span>
              </div>
              <div class="page-2-info">Social Responsibility</div>
            </div>
          </div>
          <div class="page-6-content">
            <div class="page-6-content-img">
              <img
                :class="swiperindex == 5 ? 'page-6-Ani' : ''"
                id="page-6-content-img"
                src="http://www.heywoods.cn/newImage/gy-mi.png"
              />
            </div>
            <div class="page-6-content-info">
              <p>
                小黑屋已经连续3年参与彩虹助学计划，到云南腾冲帮助那里的孩子们。
              </p>
              <div>
                他们很多成长过程其实都不完整，我们能够尽量帮助他们解决生活上的需求，却还没有办法更好的解决心理上的问题。或许我们每期的活动只能改变一点点，但是只要坚持下去，就会有复利产生。
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
var url = location.href.split("#")[0];
import { swiper, swiperSlide } from "vue-awesome-swiper";
url = encodeURIComponent(url);
let ishidden = true;
export default {
  name: "MIndex",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      itemIndex: 0,
      enterIndex: "",
      recArrTitle: ["PHP开发", "产品", "运营", "客服"],
      recArrContent: [
        {
          content: [
            "本科及以上学历，计算机相关专业，1-4年PHP互联网软件相关工作；",
            "熟练使用PHP开发，熟悉至少两种以上框架：Phalcon、Swoole、 Laravel、Yaf；",
            "熟悉Linux下的常用分布式架构方案，并能根据业务对系统及软件进行性能调优；",
            "熟悉NoSQL，熟练使用Redis、Mongo等常用非关系型数据库；",
            "熟练使用git、walle、jenkins等版本控制和代码部署工具；",
            "熟悉golang、高并发编程、微服务及docker容器技术优先；",
            "有高并发及海量数据处理经验者优先。",
          ],
        },
        {
          content: [
            "本科以上学历，有产品视角，能独立负责产品设计和规划，良好的需求分析及挖掘能力；",
            "有自我驱动的学习精神，能理解技术原理并明白如何落地；",
            "有较强的沟通能力，并协调资源高效地解决问题；",
            "熟悉微信开发优先，特别是小程序项目；",
            "有电商/社区/论坛/社交类产品项目经验。",
          ],
        },
        {
          content: [
            "有公众号运营/内容编辑经验，有一定的文字功底，擅长拟标题；",
            "具备用户思维，擅长流量转化；",
            "具备PS、视频剪辑技能优先考虑；",
            "工作细心、有上进心、有责任感；",
          ],
        },
        {
          content: [
            "要求普通话标准，能听懂部分地方方言优先；",
            "拥抱变化，为人正直，有责任心；",
            "学习能力强，做事积极主动；",
            "接受优秀实习生和应届生。",
          ],
        },
      ],
      currentwidth: "375",
      list: ["", "", "", "", "", ""],
      swiperOption: {
        //以下配置不懂的，可以去swiper官网看api，链接http://www.swiper.com.cn/api/
        preventClicksPropagation: true, //阻止click冒泡。拖动Swiper时阻止click事件。
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        //					grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        //					height: window.innerHeight, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        observeSlideChildren: true,
        on: {
          //监听滑动切换事件，返回swiper对象
          slideChange: () => {
            let swiper = this.$refs.mySwiper.swiper;
            this.swiperindex = swiper.activeIndex;
            console.log(swiper.activeIndex); //滑动打印当前索引
          },
        },
      },
      imgArr: [],
      swiperindex: 0,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    var that = this;
    that.getWidth();
    console.log(window.onresize, "window.onresize");
    wx.ready(function () {
      that.shareConfig();
    });
    that.getWxConfig();
  },
  methods: {
    slideTo: function () {
      console.log(this.$refs, "this.$refs.mySwiper");
      this.$refs.mySwiper.swiper.slideTo(this.swiperindex + 1, 1000, true); //初始滑动到哪个页面
    },
    tabClick: function (index) {
      this.itemIndex = index;
    },

    getWxConfig: function () {
      var that = this;
      $.ajax({
        type: "get",
        url:
          "https://apps.gaoecps.com/api/configs/wx-config?preset=tuijianxinxuan&url=" +
          url,
        jsonp: "callback",
        jsonpCallback: "success_jsonpCallback",
        success: function (data) {
          console.log(data, "data");
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.app_id, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonce_str, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: [
              "checkJsApi",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
            ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
        },
      });
    },
    shareConfig: function () {
      console.log("setShareConfig");
      wx.onMenuShareTimeline({
        title: "小黑屋科技", // 分享标题
        desc: "成为持久且健康的世界级企业", // 分享描述
        imgUrl: "http://www.heywoods.cn/newImage/share2021_new.png", // 分享图标
        success: function (res) {
          console.log(res, "成功onMenuShareTimelineres");
          // 用户确认分享后执行的回调函数
        },
        cancel: function (rej) {
          console.log(rej, "失败onMenuShareTimelinerej");
          // 用户取消分享后执行的回调函数
        },
      });
      wx.onMenuShareAppMessage({
        title: "小黑屋科技", // 分享标题
        desc: "成为持久且健康的世界级企业", // 分享描述
        imgUrl: "http://www.heywoods.cn/newImage/share2021_new.png", // 分享图标
        success: function (res) {
          // 用户确认分享后执行的回调函数
          console.log(res, "成功onMenuShareAppMessageres");
        },
        cancel: function (rej) {
          console.log(rej, "失败onMenuShareAppMessagerej");
          // 用户取消分享后执行的回调函数
        },
      });
    },
    getWidth: function () {
      var currentwidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      console.log(currentwidth, "currentwidthcurrentwidth");
      this.currentwidth = currentwidth;
      let scroll = currentwidth / 3;
      $("#page-6-content-img").scrollLeft(scroll);
    },
  },
};
</script>
<style scoped>
@import url("../assets/swiper/swiper-3.4.2.min.css");
.wrap_m {
  overflow-y: scroll;
}

.mySwiper_wrap {
  position: fixed;
  width: 100%;
  height: 100%;
}

.carousel_m {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
}

.swiper-pagination-bullet-active {
  background-color: white !important;
}

.item_m {
  width: 100%;
  height: 100%;
  position: relative;
}

.videoClass {
  width: 100%;
  height: 100%;
}

.img-1-m {
  width: 75%;
  left: 10%;
  height: auto;
  position: absolute;
  z-index: 2;
  top: 30%;
}

.line-wrap {
  position: fixed;
  z-index: 3;
  top: 53px;
  right: 15px;
  max-width: 18px;
}

.line-1 {
  position: relative;
  width: 100%;
}

.line {
  margin-bottom: 12px;
  width: 12px;
  right: 0;
  height: 2px;
  float: right;
  background: rgba(255, 255, 255, 0.35);
}

.whiteLine {
  background: rgba(147, 147, 147, 0.35);
}

.lineactive {
  width: 18px;
  background: rgba(255, 255, 255, 1);
}

.lineactive2 {
  width: 18px;
  background: rgba(147, 147, 147, 1);
}

.img-1ogo {
  position: fixed;
  width: 40px;
  height: 38px;
  left: 10%;
  z-index: 2;
}
.img-1ogo-1 {
  top: 10%;
}
.img-1ogo-2 {
  top: 7%;
}
.remind {
  width: 25px;
  height: 15px;
  position: fixed;
  bottom: 9%;
  z-index: 2;
  left: 50%;
  transform: translate(-50%, 0);
}

.remind > img {
  width: 25px;
  height: 15px;
}

.remindAni {
  animation: removeAni 2s 1.5s linear infinite forwards;
}

@keyframes removeAni {
  0% {
    opacity: 1;
    transform: translateY(-10px);
  }
  50% {
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

.reference {
  position: absolute;
  text-align: left;
  z-index: 2;
  bottom: 18px;
  left: 6%;
}

.reference > p {
  line-height: 6px;
  font-size: 12px;
}

.whiteColor {
  color: white;
}

.blackColor {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
}

.miniproImg {
  position: absolute;
  right: 0;
  width: 188px;
  height: 38px;
  top: 11px;
  z-index: 2;
}

.page-2-content {
  width: 100%;
  height: 100%;
  position: relative;
}
.img-2-m {
  width: 81.2%;
  left: 9.4%;
  height: auto;
  position: absolute;
  z-index: 2;
  top: 30%;
}
.page-2-content-wrap {
  width: 90%;
  margin: 0 auto;
  height: 100%;
  position: relative;
}
.jinhui {
  width: 17px;
  height: 17px;
  position: relative;
  top: -1px;
  left: -1px;
}

.page-2-header {
  position: absolute;
  top: 14%;
  left: 5%;
  z-index: 3;
}

.page-2-title {
  font-size: 22px;
  font-weight: bold;
  display: flex;
  flex-flow: row;
  height: 42px;
  align-items: center;
  color: #000000;
}

.page-2-title > div {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: black;
  margin-left: 6px;
  margin-right: 6px;
  line-height: 4.2rem;
}

.page-2-title > img {
  width: 42px;
  height: 42px;
  margin-left: 10px;
}

.page-2-info {
  color: #55c034;
  font-size: 12px;
  line-height: 12px;
}

.page-3-img2 {
  height: 100%;
}
.page-3-img2-Ani {
  animation: walkAni 40s linear infinite forwards;
}

.page-3-img {
  position: absolute;
  z-index: 3;
  width: 119px;
  height: 54px;
  right: 13px;
  bottom: 20%;
}

.page-4-Ani {
  animation: walk2Ani 20s linear infinite;
}

@keyframes walkAni {
  0% {
    transform: translateX(0%);
  }
  50% {
    /*left: -575%;
			position: absolute;*/
    transform: translateX(-83%);
  }
  100% {
    transform: translateX(0%);
  }
}
.page-6-Ani {
  animation: walk6Ani 30s linear infinite;
}
@keyframes walk6Ani {
  0% {
    transform: translateX(0%);
  }
  50% {
    transform: translateX(-64%);
  }
  100% {
    transform: translateX(0%);
  }
}
.miniproImg-4 {
  position: absolute;
  right: 0;
  width: 181px;
  height: 38px;
  top: 16px;
  z-index: 2;
}

@keyframes walk2Ani {
  0% {
    transform: translateX(0%);
  }
  50% {
    transform: translateX(-55%);
  }
  100% {
    transform: translateX(0%);
  }
}

.page-4-img {
  position: absolute;
  width: 100%;
  left: 0%;
  height: 300px;
  top: 28%;
  overflow: hidden;
}

.page-4-img > img {
  /*width: 105%;*/
  height: 100%;
}

.page-5-rec {
  position: absolute;
  width: 100%;
  top: 22%;
  left: 0%;
  /*border: 1px red solid;*/
}

.page-2-info-list {
  clear: left;
  width: 100%;
}

.page-5-title-warp {
}

.page-5-title {
  float: left;
  width: 25%;
  height: 53px;
  font-size: 16px;
  font-family: "宋体";
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 53px;
  text-align: center;
}
.titleSize {
  font-size: 20px;
}

.title {
  display: inline;
  position: relative;
  z-index: 1;
}

.borderActive {
  position: absolute;
  height: 15px;
  left: 0;
  width: 100%;
  background: rgba(85, 192, 52, 0.35);
  bottom: -3px;
  z-index: -2;
}

.page-2-info-list-item {
  font-size: 14px;
  font-family: "宋体";
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  width: 100%;
  line-height: 20px;
  margin: 0 auto;
}
.titlesize2 {
  font-size: 15px;
  line-height: 22px;
}
.page-5-end {
  position: absolute;
  bottom: 15%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
}
.page-6-content {
  position: absolute;
  top: 52%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
}
.page-6-content-img {
  width: 100%;
}
.page-6-content-img > img {
  height: 150px;
}
.page-6-content-info {
  width: 90%;
  margin: 0 auto;
  margin-top: 25px;
}
.page-6-content-info > p {
  font-size: 16px;
  text-indent: 32px;
  color: black;
  font-weight: bold;
}
.page-6-content-info > div {
  font-size: 15px;
  color: #555555;
  text-indent: 30px;
}
.miniproImg-6 {
  position: absolute;
  width: 142px;
  height: 72px;
  right: 0px;
  top: 8%;
}
</style>



// WEBPACK FOOTER //
// src/components/MIndex.vue